var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd172c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c60b1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc500"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v3.047619h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 8.380952h16v3.047619h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.047619h16v5.333333h-16z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.19047619 5.33333333h.76190476v.38095238h-.76190476z",
    fill: "#ffedb1",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#a41517"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.7447821 6.4453491c.01876125.22513509.22176441.41179376.44569409.41179376.22419173 0 .42700208-.18748957.4456941-.41179376l.09266798-1.11201577h-1.07672416zm-.47523359-1.11552892c-.01737116-.20845393.14432798-.37743923.35400372-.37743923h1.13384792c.21288202 0 .37175842.16438294.35400372.37743923l-.0955971 1.1471653c-.03502912.42034931-.40160854.76110976-.82533058.76110976-.42078838 0-.79001018-.33726502-.82533057-.76110976z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.42857143 5.71428571h1.52380952v.38095239h-.38095238l-.38095238.76190476-.38095238-.76190476h-.38095238z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.285714 4.571429h1v2.666667h-1z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.333333 4.571429h1v2.666667h-1z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.42857143 4.19047619c0-.21039419.16307431-.38095238.38452148-.38095238h.75476656c.21236535 0 .38452148.17671131.38452148.38095238v.18869164c0 .10618268-.08192662.19226074-.18684896.19226074h-1.1501116c-.10319383 0-.18684896-.08153716-.18684896-.19226074z",
    mask: "url(#e)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/ES.f5f41837e71e53b7803a50c3b6c48f9d.svg";
export { ForwardRef as ReactComponent };